// GENERATED by scripts/build-icons.mjs from icons/chart-column.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const BarChart3 = createIcon('chart-column', [
  ['path', { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
  ['path', { d: "M18 17V9" }],
  ['path', { d: "M13 17V5" }],
  ['path', { d: "M8 17v-3" }],
])
